module.exports = __webpack_public_path__ + "logotitle (2).png?7d36e053bc1c8940be381ffe12f1657b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logotitle (2).png
// module id = 4
// module chunks = 0